import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE_LABEL } from '../data/content';
export function Offer() {
  return <section id="oferta" className="scroll-mt-24 bg-cream pb-16 sm:pb-24" data-id="element-105" data-mp="1mm7j0vzbjbew">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.6
    }} className="mx-auto max-w-3xl px-5" data-id="element-106" data-mp="1ho5ys7q5p61u">
        <div className="rounded-3xl bg-ink p-6 shadow-2xl sm:p-12" data-id="element-107" data-mp="p1l530m7khv4">
          <div className="text-center" data-id="element-108" data-mp="13y2fnpmkpsgm">
            <h3 className="font-display text-xl font-black text-cream sm:text-3xl" data-id="element-109" data-mp="13uy60cqca4ik">
              Te llevás todo esto por {PRICE_LABEL}:
            </h3>
          </div>

          <ul className="mx-auto mt-8 max-w-lg space-y-4" data-id="element-110" data-mp="2fav9r72u6szu">
            {['El Método Maestro Amigurumi completo', 'BONO 1: Diccionario Universal de Puntos', 'BONO 2: Guía de Materiales Recomendados', 'BONO 3: Los 5 Patrones de Práctica', 'Patrones listos para empezar a tejer'].map(item => <li key={item} className="flex items-start gap-3 text-base font-semibold text-cream/90 sm:items-center sm:gap-4 sm:text-lg" data-id="element-111" data-mp="zjg6e4l8thr2">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-terracotta-light sm:mt-0 sm:h-6 sm:w-6" aria-hidden="true" data-id="element-112" data-mp="13hw0stjnlsei" />
                <span data-id="element-113" data-mp="btc5w63cpy4a">{item}</span>
              </li>)}
          </ul>

          <div className="mx-auto mt-10 max-w-xl" data-id="element-114" data-mp="ftm8r9vuk8ex">
            <CtaButton data-id="element-115" data-mp="kl4ai05p2d0y" />
            <p className="mt-5 flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide text-cream/60" data-id="element-116" data-mp="kle19pykco7p">
              <ShieldCheckIcon className="h-5 w-5 text-sage" data-id="element-117" data-mp="3k848m8pa88zx" />
              Pagá seguro con Mercado Pago
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}